import { ITemplateOptions, ITemplateScope } from "AngularFormly";
import { ServiceResponse } from "../../../../../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../../../records/server/serverUtility";
import { MachineGateway } from "../../../../../../models/machine";
import { MachineConfigurationGateway } from "../../../../../../models/machineConfiguration";
import {
  MachineConfigurationProgressiveInformation,
  ProgressiveDefinition,
  ProgressiveDefinitionView,
} from "../../../../../../models/progressiveDefinition";
import { set } from "lodash";
import angular, { IQService } from "angular";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../../../../records/views/recordGridView";
import { vsObjectName as progressiveDefinitionName } from "../../../../../../config/progressiveDefinition";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../../../../../records/grids/settings/gridSettingsService";
import { IRowCommandEventArgs } from "../../../../../../../../records/grids/controller";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../../../../records/grids/columns/columnDefinitionService";

interface TemplateScope extends ITemplateScope {
  fieldController: ProgressiveDefinitionSelectTypeController;
}

interface TemplateOptions extends ITemplateOptions {
  machine: MachineGateway;
  machineConfiguration: MachineConfigurationGateway;
  machineConfigurationProgressiveInformation: MachineConfigurationProgressiveInformation;
}

export class ProgressiveDefinitionSelectTypeController {
  static $inject = [
    "$scope",
    ServerUtilityName,
    "$q",
    "$uibModal",
    RecordGridViewServiceName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
  ];

  selectedProgressiveDefinition:
    | ProgressiveDefinition
    | ProgressiveDefinitionView
    | undefined;
  progressiveDefinitionQueryResults: ProgressiveDefinitionView[] = [];

  machine: MachineGateway;
  machineConfiguration: MachineConfigurationGateway;
  machineConfigurationProgressiveInformation: MachineConfigurationProgressiveInformation;

  constructor(
    private readonly $scope: TemplateScope,
    private readonly serverUtility: ServerUtility,
    private readonly $q: IQService,
    private readonly $uibModalService: angular.ui.bootstrap.IModalService,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly gridSettingsService: GridSettingsService,
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {
    $scope.fieldController = this;
    const {
      machine,
      machineConfiguration,
      machineConfigurationProgressiveInformation,
      initialProgressiveDefinition,
    } = <TemplateOptions>$scope.options.data;
    this.machine = machine;
    this.machineConfiguration = machineConfiguration;
    this.machineConfigurationProgressiveInformation =
      machineConfigurationProgressiveInformation;
    this.selectedProgressiveDefinition = initialProgressiveDefinition;
  }

  setModelProgressiveDefinitionId(progressiveDefinitionId?: number) {
    const model = this.$scope.model ?? {};
    set(model, this.$scope.options.key, progressiveDefinitionId);
  }

  progressiveSelected(
    selectedProgressiveDefinition: ProgressiveDefinitionView
  ) {
    this.selectedProgressiveDefinition = selectedProgressiveDefinition;
    const progressiveDefinitionId = selectedProgressiveDefinition?.Id;
    this.setModelProgressiveDefinitionId(progressiveDefinitionId);

    if (!this.$scope.to.showProgressiveInfo) {
      return this.$q.when();
    }

    if (!progressiveDefinitionId) {
      this.machineConfigurationProgressiveInformation = {
        Games: [],
        MachineConfigurationId: this.machineConfiguration.Id,
        ProgressiveDefinition: undefined,
      };

      return;
    }

    const machineConfigurationId = this.machineConfiguration.Id;
    const url = `/api/machines/MachineConfiguration/${machineConfigurationId}/progressiveInformation`;
    return this.serverUtility
      .post<ServiceResponse<MachineConfigurationProgressiveInformation>>({
        url,
        postObject: {
          progressiveDefinitionId,
        },
      })
      .then((r) => {
        this.machineConfigurationProgressiveInformation = r.Result;
      });
  }

  queryProgressiveDefinitions(select: any) {
    this.serverUtility
      .query({
        query: {
          GameProgramNumberContains: select.search,
          OrderBy: "GameProgramNumber,Name",
          Take: 10,
        },
        url: "/api/machines/progressives/ProgressiveDefinition",
      })
      .then((result) => {
        const queryResults = <ProgressiveDefinitionView[]>result.Results;
        queryResults.forEach((r) => {
          r.Name = r.ProgressiveDefinitionName;
        });
        this.progressiveDefinitionQueryResults = queryResults;
      });
  }

  showSelectModal() {
    let instance: angular.ui.bootstrap.IModalInstanceService;
    const gridConfiguration = this.recordGridViewService.getGridConfiguration(
      progressiveDefinitionName
    )!;

    gridConfiguration.columns = [
      this.columnDefinitionService.getCommandColDef({
        name: "select",
        iconClass: "fa fa-plus-circle text-primary",
        headerName: "select",
      }),
      ...(gridConfiguration.columns ?? []),
    ];

    gridConfiguration.gridSettings = this.gridSettingsService.getGridSettings(
      Symbol("progressiveDefinitionSelect.grid")
    );

    gridConfiguration.onItemCommand = (
      args: IRowCommandEventArgs<ProgressiveDefinitionView>
    ) => {
      if (args.commandName === "select") {
        instance.close(args.data);
      }
      return this.$q.when();
    };

    instance = this.$uibModalService.open({
      template: require("!html-loader!./modalTemplate.html").default,
      controller: [
        "$uibModalInstance",
        ($uibModalInstance: angular.ui.bootstrap.IModalInstanceService) => {
          $uibModalInstance.rendered.then(() => {
            const width = "950px";
            var modalWindow = angular.element(
              document.querySelector(".modal-content")!
            );
            modalWindow.css("width", width);
          });
        },
      ],
      resolve: {
        gridConfiguration: [() => gridConfiguration],
      },
    });
    instance.result.then((r) => {
      this.progressiveSelected(r);
    });
  }
}
